import { TrueLarkPromoSource } from './constants';

export const TRUE_LARK_TRACKING_ID_PREFIX = 'true-lark-missed-call-promo';

export const generateTrueLarkPromoTrackingId = ({
  source,
  action,
}: {
  source: TrueLarkPromoSource;
  action: string;
}) => {
  return `${TRUE_LARK_TRACKING_ID_PREFIX}:${source}:${action}`;
};
